/* Investigation board: photo-real pushpins (sprite sheet, 6 poses x 5 colours) on every print + the note card. Pose sizes tuned so every pin reads about the same size. */
(function(){
  var NS='http://www.w3.org/2000/svg', XL='http://www.w3.org/1999/xlink';
  var SHEET='https://cdn.shopify.com/s/files/1/0523/0161/files/rad-pins-sheet.png?v=1792716322', CELL=96, COLS=5, ROWS=6;
  var POSE=[[26,.45,.55,25],[22,.17,.88,6],[36,.5,.8,14],[33,.5,.8,14],[31,.5,.8,14],[28,.5,.8,14]];
  var ORDER=[2,0,3,1,4,5,3,2,0,5,4,1], n=0, uid=0;
  function pinPoint(el,slide){
    var sr=slide.getBoundingClientRect(), r=el.getBoundingClientRect();
    var cx=r.left+r.width/2-sr.left, cy=r.top+r.height/2-sr.top;
    var h=el.offsetHeight,ang=0,m=getComputedStyle(el).transform;
    if(m&&m!=='none'){var v=m.match(/matrix\(([^)]+)\)/);if(v){var p=v[1].split(',').map(parseFloat);ang=Math.atan2(p[1],p[0]);}}
    var d=h/2-10; return {x:cx+Math.sin(ang)*d, y:cy-Math.cos(ang)*d, a:ang*180/Math.PI};
  }
  function mk(t,a,p){var e=document.createElementNS(NS,t);for(var k in a)e.setAttribute(k,a[k]);if(p)p.appendChild(e);return e}
  function pin(svg,id,x,y,rot,i){
    var pose=ORDER[(i+n)%ORDER.length], col=(i*2+n+Math.floor(i/3))%COLS;
    var P=POSE[pose], size=P[0];
    var tilt=((i*37+n*53)%100/100-.5)*2*P[3]+rot*.5;
    var g=mk('g',{transform:'translate('+x+' '+y+') rotate('+tilt+')'},svg);
    var ax=P[1]*size, ay=P[2]*size;
    mk('ellipse',{cx:size*.22,cy:size*.1,rx:size*.3,ry:size*.12,fill:'rgba(25,10,0,.55)',filter:'url(#'+id+'s)'},g);
    var nest=mk('svg',{x:-ax,y:-ay,width:size,height:size,viewBox:(col*CELL)+' '+(pose*CELL)+' '+CELL+' '+CELL,overflow:'hidden'},g);
    var im=mk('image',{x:0,y:0,width:CELL*COLS,height:CELL*ROWS},nest);
    im.setAttributeNS(XL,'href',SHEET);im.setAttribute('href',SHEET);
  }
  function draw(slide){
    var old=slide.querySelector('.rad-board__svg'); if(old)old.remove();
    var els=[].slice.call(slide.querySelectorAll('.rad-slide__print,.rad-slide__side,.rad-slide__strip'));
    if(!els.length)return;
    var sr=slide.getBoundingClientRect(), id='rb'+(++uid);
    var svg=mk('svg',{'class':'rad-board__svg','viewBox':'0 0 '+sr.width+' '+sr.height,'aria-hidden':'true'});
    var d=mk('defs',{},svg),f=mk('filter',{id:id+'s',x:'-60%',y:'-60%',width:'220%',height:'220%'},d);mk('feGaussianBlur',{stdDeviation:'1.8'},f);
    els.forEach(function(e,i){var p=pinPoint(e,slide);pin(svg,id,p.x,p.y,p.a,i)});
    slide.appendChild(svg);
    requestAnimationFrame(function(){svg.classList.add('is-on')});
  }
  function init(root){
    var slides=[].slice.call(root.querySelectorAll('.rad-slide')),t;
    function redraw(){n=0;slides.forEach(function(s,k){if(s.classList.contains('is-on')){n=k*5;draw(s)}else{var o=s.querySelector('.rad-board__svg');if(o)o.remove()}})}
    function later(){clearTimeout(t);slides.forEach(function(s){var o=s.querySelector('.rad-board__svg');if(o)o.classList.remove('is-on')});t=setTimeout(redraw,780)}
    var mo=new MutationObserver(later);slides.forEach(function(s){mo.observe(s,{attributes:true,attributeFilter:['class']})});
    window.addEventListener('resize',later);window.addEventListener('load',later);
    later();
  }
  function ready(){document.querySelectorAll('.rad-slider--featured').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();